import Vue from 'vue'
import Index from './Index.vue'
Vue.config.productionTip = false

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import AnimateCss from 'animate.css';
Vue.use(AnimateCss);

import '../../../assets/font/myFont.css'

new Vue({
    render: h => h(Index),
}).$mount('#index')